import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { appService } from '../../../_services/app.service';

@Component({
  selector: 'app-history-tooltip',
  templateUrl: './history-tooltip.component.html',
  styleUrls: ['./history-tooltip.component.scss']
})
export class HistoryTooltipComponent implements OnInit,OnChanges  {

  @Input() records: any[] = [];
  @Input() recordId: any;
  @Input() Type: any;
  constructor(
     private _appService: appService, 
     private toastr: ToastrService,
  ) { }

  ngOnInit() {
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['recordId'] || changes['Type']) {
      this.fetchHistory(this.recordId,this.Type);
    }
  }


  fetchHistory(id,Type){
    this._appService.GetByTwoParam('OrdersByVehicle','GetChangedHistoryList',id,Type).subscribe(
      (response)=>{
        // this.records = response || [];
        const filtered = (response || []).filter(
          (r: any) => r.Timestamp && r.UserName && r.UserName.trim() !== ''
        );

        this.records = filtered;
      },
      (error)=>{
         this.records = [];
        // this.toastr.info('History Not Found');
      }
    );
  }
}
